var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "-2 -1 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.93925 4.97487L5.9375 6.30144V12.8652C5.9375 13.9868 6.84692 14.896 7.96875 14.896L13.3539 14.8962C13.1608 15.4421 12.64 15.8333 12.0278 15.8333H7.96875C6.32916 15.8333 5 14.5045 5 12.8652V6.30144C5 5.68862 5.39216 5.16738 5.93925 4.97487ZM13.5938 3.33331C14.3704 3.33331 15 3.96278 15 4.73927V12.8626C15 13.639 14.3704 14.2685 13.5938 14.2685H7.96875C7.1921 14.2685 6.5625 13.639 6.5625 12.8626V4.73927C6.5625 3.96278 7.1921 3.33331 7.96875 3.33331H13.5938ZM13.5938 4.27062H7.96875C7.70987 4.27062 7.5 4.48044 7.5 4.73927V12.8626C7.5 13.1214 7.70987 13.3312 7.96875 13.3312H13.5938C13.8526 13.3312 14.0625 13.1214 14.0625 12.8626V4.73927C14.0625 4.48044 13.8526 4.27062 13.5938 4.27062Z",
    fill: "#96C11F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.24d4b81220fd449c834dd829c3b0101d.svg";
export { ForwardRef as ReactComponent };